// extracted by mini-css-extract-plugin
export default {"overlayContainer":"StaffSelectPageOverlay_overlayContainer__LRhZz"};